import styled from 'styled-components';

const CreateContentWrapper = styled.div`
  .editor {
    min-height: 50vh;
  }

  .story-youtube-video-container {
    padding-bottom: 24px;
  }
  .form-component {
    margin-bottom: 0 !important;
  }

  .editor-link-section {
    input {
      border: 1px solid ${({ theme }) => theme.colors.status[20]} !important;
      background: ${({ theme }) => theme.colors.white[100]};
      font-size: 16px;
      padding: 0px 12px !important;
    }
    input[type='checkbox'] {
      padding: 0 !important;
    }
  }

  .no-data-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .content-title {
    margin-bottom: 24px;
  }
  .content-container {
    video,
    img {
      max-width: 48vw;
      max-height: 27vw;
    }
    line-height: 28px;
    padding-bottom: 48px;
  }
  .story-title-section {
    padding-bottom: 48px;
  }
  .card-list-box {
    box-sizing: border-box;
    .resource-status {
      max-width: 1000px !important;
    }
  }
  .tinymce-wrapper {
    position: relative;
  }
  .tinymce-wrapper .autosave-content {
    position: absolute;
    bottom: 35px;
    right: 20px;
  }

  .tiptap-autosave-content {
    position: absolute;
    bottom: 60px;
    right: 100px;
  }
  .button-section {
    margin-top: 20px;
  }
  .video-primary-status-color {
    background-color: ${({ theme }) => theme.colors.error[600]};
  }
  .video-completed-status-color {
    background-color: ${({ theme }) => theme.colors.primary[600]};
  }

  .content {
    background-color: ${({ theme }) => theme.colors.background[15]};
    border-radius: 8px;
    overflow-x: hidden;
    flex: 1;
  }

  .title-block {
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  }

  .input-content {
    display: flex;
    align-items: center;
    textarea {
      height: 24px;
      max-height: 120px;
      resize: none;
      min-height: 20px;
      min-width: 100%;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      color: ${({ theme }) => theme.colors.dark[100]};
      background-color: inherit;
      border: none;
      padding: 0;
    }
  }

  .tooltip-child {
    display: flex;
    align-items: center;
  }

  .help-icon {
    path {
      &.stroke {
        stroke: ${({ theme }) => theme.colors.dark[60]} !important;
      }
      &.fill {
        fill: ${({ theme }) => theme.colors.dark[60]} !important;
      }
    }
  }
`;

export default CreateContentWrapper;
